import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/vercel/path0/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "encodabledimension"
    }}>{`@encodable/dimension`}</h1>
    <p><a parentName="p" {...{
        "href": "https://img.shields.io/npm/v/@encodable/dimension.svg?style=flat"
      }}><img alt="Version" src="https://img.shields.io/npm/v/@encodable/dimension.svg?style=flat" /></a>{`
`}<a parentName="p" {...{
        "href": "https://david-dm.org/kristw/encodable?path=packages/encodable-dimension"
      }}><img alt="David (path)" src="https://img.shields.io/david/kristw/encodable.svg?path=packages%2Fencodable-dimension&style=flat-square" /></a></p>
    <p>{`Utilities for managing dimension.`}</p>
    <h2 {...{
      "id": "install"
    }}>{`Install`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-sh"
      }}>{`npm install @encodable/dimension
`}</code></pre>
    <h2 {...{
      "id": "apis"
    }}>{`APIs`}</h2>
    <h3 {...{
      "id": "gettextdimension"
    }}>{`getTextDimension(...)`}</h3>
    <p>{`Get dimension (width & height) of a rendered text.`}</p>
    <h4 {...{
      "id": "signature"
    }}>{`Signature`}</h4>
    <pre><code parentName="pre" {...{
        "className": "language-ts"
      }}>{`function getTextDimension(
  input: {
    className?: string;
    container?: HTMLElement;
    style?: TextStyle;
    text: string;
  },
  defaultDimension?: Dimension
): Dimension;
`}</code></pre>
    <h4 {...{
      "id": "example"
    }}>{`Example`}</h4>
    <pre><code parentName="pre" {...{
        "className": "language-ts"
      }}>{`import { getTextDimension } from '@encodable/dimension';

getTextDimension({ text: 'abcdef' });
`}</code></pre>
    <h3 {...{
      "id": "getmultipletextdimension"
    }}>{`getMultipleTextDimension(...)`}</h3>
    <p>{`Same with `}<inlineCode parentName="p">{`getTextDimension()`}</inlineCode>{` but takes an array of strings which is more efficient for batch computation.`}</p>
    <h3 {...{
      "id": "computemaxfontsize"
    }}>{`computeMaxFontSize(...)`}</h3>
    <p>{`Compute maximum font size to fit in the the given container.`}</p>
    <h3 {...{
      "id": "parselength"
    }}>{`parseLength()`}</h3>
    <p>{`Parse length from string or number;`}</p>
    <h3 {...{
      "id": "mergemargin"
    }}>{`mergeMargin(...)`}</h3>
    <p>{`Merge two margin objects`}</p>
    <h3 {...{
      "id": "mergepadding"
    }}>{`mergePadding(...)`}</h3>
    <p>{`Merge two padding objects`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      